export { default } from './SearchProviderView.tsx'
